import cx from 'classnames'
import { scaleThreshold } from 'd3-scale'
import { floor, size } from 'lodash/fp'
import { D3Legend } from '~/components/d3/D3Legend'
import Histogram from '~/components/Histogram'
import { CONFLUENCY_COLORS } from '../constants'
import cs from './confluence_histogram.scss'

function ConfluenceHistogram(props: {
  confluencyValues: number[]
  label?: string
  className?: string
}) {
  const { confluencyValues, className, label } = props
  // Hard-code these y-max values for now to look nice.
  let yMax = 2
  if (size(confluencyValues) > 5) {
    yMax = 6
  }

  if (size(confluencyValues) > 25) {
    yMax = 20
  }

  if (size(confluencyValues) > 150) {
    yMax = 100
  }

  if (size(confluencyValues) > 500) {
    yMax = 400
  }

  const marginLeft = 40 // Accommodates Y axis labels

  return (
    <div className={cx(cs.confluenceHistogram, className)}>
      {size(confluencyValues) > 0 ? (
        <Histogram
          className={cs.histogram}
          data={confluencyValues}
          layoutOptions={{
            marginLeft,
            marginRight: 1,
            marginBottom: 0,
            marginTop: 5, // Accommodates top Y axis label text
          }}
          axisOptions={{
            showXAxis: false,
            yTicks: 2,
            yTickFormat: (n: number) => (n > 0 ? `${n}` : ''),
            yAxisClassName: cs.yAxis,
            yLabel: '# wells',
            yLabelBuffer: marginLeft - 10,
            yLabelClassName: cs.label,
            yTickLineClassName: (n: number) => (n === 0 ? cs.hideTickLine : undefined),
          }}
          options={{
            xDomain: [0, 100],
            yDomain: [0, yMax],
            bins: 50,
            hoverBins: 50,
            getBarColor: (x0: number, x1: number) => {
              const index = floor((x0 + x1) / 2 / 20)
              return CONFLUENCY_COLORS[index]
            },
          }}
        />
      ) : (
        <div className={cs.histogram} />
      )}

      {D3Legend(scaleThreshold([20, 40, 60, 80], CONFLUENCY_COLORS), {
        marginLeft,
      } as any)}
      <div className={cs.label}>{label || 'Confluence (%)'}</div>
    </div>
  )
}

export default ConfluenceHistogram
